export const FETCH_LATEST_NEWS_REQUEST = 'FETCH_LATEST_NEWS_REQUEST';
export const FETCH_LATEST_NEWS_SUCCESS = 'FETCH_LATEST_NEWS_SUCCESS';
export const FETCH_LATEST_NEWS_FAILURE = 'FETCH_LATEST_NEWS_FAILURE';

export const SET_NEWS = 'SET_NEWS';
export const ADD_TO_NEWS = 'ADD_TO_NEWS';
export const UPDATE_NEWS_ITEM = 'UPDATE_NEWS_ITEM';
export const DELETE_FROM_NEWS = 'DELETE_FROM_NEWS';
export const SET_NEWS_UNIQUE = 'SET_NEWS_UNIQUE';
